import React from "react";
import * as actions from '../Actions';
export default function UploadFrame({ eleRef, ContestData,ProductData,Msg,tool }) {
    return (
        <div className={tool=="MB"?"mybumpie-tag":"face-tag"}>
            { tool=="MB" ?(
                <div>
                <span className="tag-text R15_9e"></span>
                <div className="tag-slider">
                    <div className="M15_42 slide-tag tagkids_1" data-id="1" onClick={(e) => { actions.SlideTag(e,eleRef) }}>
                        <span className="arrow-icon M14_9e" data-icon-font='<' data-id="1" name="myself" id="myself" value="1"></span>
                        Myself
                </div>
                </div>
                <div className="tell_us_more">
                    <input type="text" id="photodesc" className="R15_9e" name="photodesc" placeholder="" maxLength="250" autoComplete="off" />
                    <label className="textfield-label">Tell us more about this pic</label>
                    <br />
                </div>
                </div>):(
                    <div>
                        <div className="tell_us_more">
                        <textarea
                            className="R15_9e"
                            id="photodesc"
                            placeholder="Tell us more about this pic"
                            value={eleRef.state.hashTag || ""}
                            onChange={(e) => eleRef.setState({ hashTag: e.target.value })}
                        />
                        </div>
                        <span className="tag-text R15_9e">Tag kids present in this face a day</span>
                        <div className="tag-slider">
                        {eleRef.state.childListData && eleRef.state.childListData.length > 0 && eleRef.state.childListData.map((result,index) => result.ChildName==eleRef.state.childName ?
                            (<div key={index} className={"M15_42 slide-tag slide-tag-active tagkids_"+result.ChildId} data-id={result.ChildId} style={{display: "inline-block"}}>
                                <span className="arrow-icon childname M14_9e" id="childname" data-icon-font='<' data-id={result.ChildId}></span>
                                {eleRef.state.childName}
                                <span className="child-age childage" id="childage">
                                {result.Age}
                                </span>
                            </div>):null
                            )}
                            <div className="M15_42 slide-tag tagkids_1" data-id="1" onClick={(e) => { actions.SlideTag(e,eleRef) }} style={{display: "inline-block"}}>
                            <span className="arrow-icon M14_9e" data-icon-font='<' data-id="1" name="myself" id="myself" value="1"></span>
                            Myself
                            </div>
                        </div>
                    </div>
                )            
            }
            
            <div className="contest_dropdown">
                <span className="R15_42 par_lable">Participating in</span>
                <div className="drop_down_select" onClick={() => { actions.showOptions(ContestData) }}>
                    
                    { eleRef.state.contestId ?

                        ContestData && ContestData.length > 0 && ContestData.map(contestArr => contestArr.contestId == eleRef.state.contestId ?
                            <span className="R15_42 selected_option left">
                                {contestArr.title}
                            </span> : null
                        )
                        :
                        (<span><span className="R15_9e" id="selconst">Select Contest</span>
                        <span className="icon right" data-icon-font="j"></span></span>)
                    }
                    
                </div>
                    <div className="options_overlay">
                        <div className="option_list">
                            <span className="M14_42">Active Contest</span>
                            <ul>
                                {ContestData && ContestData.length > 0 && ContestData.map((contestArr, index) =>
                                    <li key={index} onClick={() => { actions.selected_contest(contestArr.title, contestArr.contestId,eleRef) }}>
                                        <span className="R15_42">
                                            {contestArr.title}
                                        </span>
                                    </li>
                                )}
                            </ul>
                        </div>
                    </div>
            </div>
            {tool=="MB" ?
                (tool=="MB" && Msg =='1'? 
                <div>
                 <div className="shop-items">
                     <span className="txt-shop M14_42">SHOPPABLE ITEMS IN THIS PIC</span>
                     <span className="div-underline"></span>
                 </div>
                 <div className="shop-items-wrap">
                     {ProductData && ProductData.length>0 && ProductData.map(prodArr=>
                         <div>
                             <a href="javascript:void(0);">
                                 <div className={"shop-item prod_tag_"+prodArr['productId']} onClick={()=>{eleRef.ShopItem(prodArr['productId'])}} data-id={prodArr['productId']}>
                                     <img  src={"//cdn.fcglcdn.com/brainbees/images/products/438X531/"+prodArr['productId']+"a.jpg"} data-id={prodArr['productId']}  alt={"//cdn.fcglcdn.com/brainbees/images/products/438X531/"+prodArr['productId']+"a.jpg"} title={"//cdn.fcglcdn.com/brainbees/images/products/438X531/"+prodArr['productId']+"a.jpg"}/>
                                     <span></span>
                                 </div>
                             </a>
                         </div> 
                 )} 
                </div></div>:null):null            
            }
            <div className="float-field">
                <span className="icon select-all checkbox checkAll" data-icon-font="z" id="setpic" value="0" onClick={(e) => { actions.myProfile_status(e) }}>
                </span>
                <span className="M15_42 check-text">Use this as my profile picture</span>
            </div>
            <div className="choose_photo_btns">
                <label htmlFor={tool=="MB"?"mybumpie_upload":"face_upload"}>
                    <span className={tool=="MB"?"askB_1 upload_btn":"askB_1 choose_btn"}>
                        <span data-icon-font="" className="icon"></span>
                        <span className="B14_white">{tool=="MB"? "Upload Your Bumpie":"Choose Your Photo"}</span>
                    </span>
                </label>
            </div>
            <div className="upload_photo_btns">
                <span className="askB_1 upload_btn" id={tool=="MB"?"add_mybumpie":"add_face"} onClick={()=>{eleRef.UploadPhoto()}}>
                    <span className="B14_white">{tool=="MB"?"Upload Photo":"Upload Face A Day"}</span>
                </span>
                <span className="askB_1 cancle_btn" onClick={()=>{eleRef.CancleButton()}}>
                    <span className="B14_white">Cancel</span>
                </span>
            </div>
        </div>
    );
}
